'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _CloseSmall, _ArrowIosUp, _ArrowIosDown, _Filter;
var _excluded = ["children", "multiselect", "onClear", "filterIcon", "hideArrow", "hideFilterIcon", "displayCategoryAsLabel", "className"];
import React from 'react';
import ArrowIosDown from '@crehana/compass.icons.outline/ArrowIosDown';
import ArrowIosUp from '@crehana/compass.icons.outline/ArrowIosUp';
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import Filter from '@crehana/compass.icons.outline/Filter';
import { Chip } from "../Chip";
import { cn } from "../utils";
import { useDropdownContext } from "./context";
import { DropdownTrigger } from "./Dropdown";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var DropdownFilterButton = function DropdownFilterButton(_ref) {
  var _selectedValueOnButto;
  var children = _ref.children,
    multiselect = _ref.multiselect,
    onClear = _ref.onClear,
    filterIcon = _ref.filterIcon,
    hideArrow = _ref.hideArrow,
    _ref$hideFilterIcon = _ref.hideFilterIcon,
    hideFilterIcon = _ref$hideFilterIcon === void 0 ? false : _ref$hideFilterIcon,
    _ref$displayCategoryA = _ref.displayCategoryAsLabel,
    displayCategoryAsLabel = _ref$displayCategoryA === void 0 ? false : _ref$displayCategoryA,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useDropdownContext = useDropdownContext(),
    open = _useDropdownContext.open,
    selectedItems = _useDropdownContext.selectedItems,
    setValues = _useDropdownContext.setValues,
    setOpen = _useDropdownContext.setOpen;

  // selectedItems tiene la estructura [itemLabel, categoryLabel] o [itemLabel]
  // Si displayCategoryAsLabel es true y hay un segundo item (categoría), mostrar la categoría
  var selectedValueOnButton = function selectedValueOnButton() {
    // Si displayCategoryAsLabel es true y hay un segundo item (categoría), mostrar la categoría
    if (displayCategoryAsLabel) {
      return selectedItems[1] && !multiselect ? selectedItems[1].label : undefined;
    }
    return selectedItems[0] && !multiselect ? selectedItems[0].label : undefined;
  };
  var renderTrailingIcon = function renderTrailingIcon() {
    if (selectedValueOnButton()) {
      var handleClear = function handleClear(event) {
        event.stopPropagation();
        setValues([]);
        setOpen(false);
        if (onClear) onClear();
      };
      return /*#__PURE__*/_jsx("span", {
        onClick: handleClear,
        className: "tw-rounded-full tw-w-2 tw-h-2 group-hover:tw-bg-primary-light-500 group-hover:dark:tw-bg-secondary-light-500 tw-flex tw-items-center tw-justify-center",
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          className: "group-hover:tw-text-neutral-light-100 tw-text-primary-light-500 dark:tw-text-secondary-light-500",
          size: 16
        }))
      });
    }
    if (open) return _ArrowIosUp || (_ArrowIosUp = /*#__PURE__*/_jsx(ArrowIosUp, {
      className: "tw-text-inherit",
      size: 20
    }));
    return _ArrowIosDown || (_ArrowIosDown = /*#__PURE__*/_jsx(ArrowIosDown, {
      className: "tw-text-inherit",
      size: 20
    }));
  };
  return /*#__PURE__*/_jsx(DropdownTrigger, _objectSpread(_objectSpread({
    asChild: true
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("button", {
      role: "combobox",
      "aria-expanded": open,
      className: cn('tw-w-fit tw-group tw-h-3.6 tw-px-1.2 tw-flex tw-items-center tw-justify-between tw-font-link1 tw-gap-0.8 tw-transition-colors', 'tw-rounded-1 tw-border tw-border-solid tw-border-neutral-light-500 dark:tw-border-neutral-dark-700', 'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700', 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100', 'hover:tw-border-primary-light-500 hover:tw-text-primary-light-500 dark:hover:tw-border-secondary-light-500 dark:hover:tw-text-secondary-light-500', 'active:tw-bg-primary-light-500 active:tw-text-neutral-light-100 dark:active:tw-bg-secondary-light-500 dark:active:tw-text-elevation-dark-02', 'aria-expanded:tw-bg-primary-light-500 aria-expanded:tw-text-neutral-light-100 dark:aria-expanded:tw-bg-secondary-light-500 dark:aria-expanded:tw-text-elevation-dark-02', 'disabled:tw-bg-neutral-light-400 disabled:tw-text-neutral-light-600 disabled:tw-border-neutral-light-400 dark:disabled:tw-bg-neutral-dark-500 dark:disabled:tw-text-neutral-dark-600 dark:disabled:tw-border-neutral-dark-500', Boolean(selectedValueOnButton) && 'tw-border-primary-light-500 tw-text-primary-light-500 dark:tw-border-secondary-light-500 dark:tw-text-secondary-light-500', className),
      children: [!hideFilterIcon && (filterIcon !== null && filterIcon !== void 0 ? filterIcon : _Filter || (_Filter = /*#__PURE__*/_jsx(Filter, {
        className: "tw-text-inherit",
        size: 16
      }))), (_selectedValueOnButto = selectedValueOnButton()) !== null && _selectedValueOnButto !== void 0 ? _selectedValueOnButto : children, !hideArrow && renderTrailingIcon()]
    })
  }));
};
export var DropdownFilterValues = function DropdownFilterValues(_ref2) {
  var _items$;
  var _ref2$removeAllButton = _ref2.removeAllButtonCount,
    removeAllButtonCount = _ref2$removeAllButton === void 0 ? 4 : _ref2$removeAllButton,
    _ref2$clearSelectionL = _ref2.clearSelectionLabel,
    clearSelectionLabel = _ref2$clearSelectionL === void 0 ? 'Borrar todo' : _ref2$clearSelectionL,
    onSelectChange = _ref2.onSelectChange;
  var _useDropdownContext2 = useDropdownContext(),
    selectedItems = _useDropdownContext2.selectedItems,
    items = _useDropdownContext2.items,
    setValues = _useDropdownContext2.setValues;
  if (((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.type) === 'option') throw new Error("Option values aren't still not developed for DropdownFilterValues. Please do it manually.");

  // Función que se llama cuando se borra un ítem individual
  var handleItemRemoved = function handleItemRemoved(value) {
    var newSelectedItems = selectedItems.filter(function (item) {
      return item.value !== value;
    });
    var newValues = newSelectedItems.map(function (item) {
      return item.value;
    });
    setValues(newValues); // Actualiza los valores
    if (onSelectChange) onSelectChange(newValues);
  };

  // Función que se llama cuando se limpian todos los ítems
  var handleClearAll = function handleClearAll() {
    setValues([]); // Limpia todos los valores seleccionados
    if (onSelectChange) {
      onSelectChange([]);
    } // Notifica al padre que todos los valores fueron eliminados
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [selectedItems.map(function (item) {
      return /*#__PURE__*/_jsx(Chip, {
        variant: "close",
        onClose: function onClose() {
          return handleItemRemoved(item.value);
        },
        children: item.label
      }, item.value);
    }), removeAllButtonCount > 0 && selectedItems.length >= removeAllButtonCount && /*#__PURE__*/_jsx(Chip, {
      className: "tw-text-primary-light-400 dark:tw-text-secondary-dark-300 tw-border-primary-light-400 dark:tw-border-secondary-dark-300",
      variant: "choices",
      onClick: handleClearAll,
      children: clearSelectionLabel
    })]
  });
};